import React from 'react'
import { string, func } from 'prop-types'
import { Typography, Notification } from '@telus-uds/components-web'

export const RemainingAFBalanceNotification = ({ lang, translate }) => {
  return (
    <Notification dismissible data-testid="remaining-af-balance-notification" copy={lang}>
      <Typography variant={{ size: 'medium' }}>
        {translate('appNotification.remainingAFBalanceNotification')}
      </Typography>
    </Notification>
  )
}

RemainingAFBalanceNotification.propTypes = {
  lang: string.isRequired,
  translate: func.isRequired
}
